import CookiesBlockedAlert from './cookies-blocked-alert.vue';

export default CookiesBlockedAlert;
